import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../services/api';
import PrivacyNoticeLink from '../components/PrivacyNoticeLink';

const cardStyle = {
  width: '100%',
  maxWidth: 400,
  background: '#ffffff',
  border: '1px solid #dbe5f3',
  borderRadius: 14,
  padding: 28,
  boxShadow: '0 14px 36px rgba(30, 58, 95, 0.12)',
};

export default function ForgotPassword({ setupInvitation = false }: any) {
  const [email, setEmail] = useState<any>('');
  const [message, setMessage] = useState<any>('');
  const [error, setError] = useState<any>('');
  const [loading, setLoading] = useState<any>(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const result = await requestPasswordReset(email);
      setMessage(setupInvitation
        ? 'If an eligible account matches that email, a new setup email has been sent. If setup is already complete, you will receive a password reset email instead.'
        : result.message || 'If an account matches that email, a password reset link has been sent.');
    } catch (requestError: any) {
      setError(requestError.message || (setupInvitation ? 'Could not request a new setup email.' : 'Could not request a password reset.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20, background: 'linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)' }}>
      <section style={cardStyle}>
        <h1 style={{ margin: 0, color: '#1e3a5f', fontSize: 25 }}>{setupInvitation ? 'Request a new setup email' : 'Reset your password'}</h1>
        <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>{setupInvitation
          ? 'Invitation expired? Enter the email address your school used to invite you. We will send a fresh setup link valid for 24 hours. Use the newest email; previous links will no longer work.'
          : 'Enter your account email and we will send a password reset link.'}</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="reset-email" style={{ display: 'block', color: '#374151', fontSize: 13, fontWeight: 700, marginBottom: 6 }}>Email address</label>
          <input id="reset-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required autoComplete="email" style={{ width: '100%', boxSizing: 'border-box', padding: '11px 12px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 15 }} />
          {message && <div role="status" style={{ marginTop: 14, padding: 10, borderRadius: 8, color: '#166534', background: '#f0fdf4', border: '1px solid #bbf7d0', fontSize: 13 }}>{message}</div>}
          {error && <div role="alert" style={{ marginTop: 14, padding: 10, borderRadius: 8, color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', fontSize: 13 }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ width: '100%', marginTop: 18, padding: '11px 14px', border: 'none', borderRadius: 8, background: loading ? '#93b4ed' : '#3256a2', color: '#ffffff', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}>{loading ? 'Sending...' : setupInvitation ? 'Send new setup email' : 'Send reset link'}</button>
        </form>
        <div style={{ marginTop: 14 }}><PrivacyNoticeLink /></div>
        <Link to="/login" style={{ display: 'inline-block', marginTop: 12, color: '#2563eb', fontSize: 13, fontWeight: 700 }}><span aria-hidden="true">← </span>Back to sign in</Link>
      </section>
    </main>
  );
}